import { useState } from "react";

export const useThemeManagement = () => {
  const [themesModal, setThemesModal] = useState(false);
  const [confirmTheme, setConfirmTheme] = useState({
    isVisible: false,
    message: "Atenção",
  });
  const [theme, setTheme] = useState("");
  const [messageError, setMessageError] = useState({ message: "" });

  const dataThemes = [
    { fieldName: "generic.dark", fieldCaption: "Dark" },
    { fieldName: "generic.softblue", fieldCaption: "Soft Blue" },
    { fieldName: "generic.greenmist", fieldCaption: "Green Mist" },
    { fieldName: "generic.darkviolet", fieldCaption: "Dark Violet" },
    { fieldName: "generic.carmine", fieldCaption: "Carmine" },
    { fieldName: "generic.darkmoon", fieldCaption: "Dark Moon" },
  ];

  const selectedTheme = (sender) => {
    window.localStorage.setItem("dx-theme", `${sender}`);
    window.location.reload();
  };

  return {
    themesModal,
    setThemesModal,
    confirmTheme,
    setConfirmTheme,
    theme,
    setTheme,
    messageError,
    setMessageError,
    dataThemes,
    selectedTheme,
  };
};
